import React, { FC, useState, useEffect } from 'react';
import moment from 'moment';
import { DatePicker, ButtonWithIconAndLoader } from '@td-client-frontend/common';
import Modal from '../../../../components/Modal/NewModal';
import { toast } from 'react-toastify';
import { Button } from '../../../../components/Button';
import { useMemberDetails } from '../../../../hooks/useMemberDetail';
import { MemberModalProps } from '../MembersTable';

const DATE_DISPLAY_FORMAT: string = 'MM/DD/YYYY';
const DATE_API_FORMAT: string = 'YYYY-MM-DD';

export const MemberTerminationModal: FC<MemberModalProps> = ({
  isOpen,
  onClose,
  member,
  setSelectedMember,
  onComplete
}) => {
  const { terminateMember } = useMemberDetails();

  const [termDate, setTermDate] = useState<string>();
  const [disabledBtn, setDisabledBtn] = useState<boolean | undefined>(false);

  const [isLoading, setIsLoading] = useState<boolean>(false);

  useEffect(() => {
    if (!termDate) {
      setDisabledBtn(true);
    } else if (termDate) {
      setDisabledBtn(false);
    }
  }, [termDate]);

  const handleMemberTermination = async () => {
    setDisabledBtn(true);
    setIsLoading(true);
    try {
      // @ts-ignore
      const result = await terminateMember({ memberId: member?.mrnId, effectiveEndDt: termDate });
      if (result && !result.errors?.length) {
        toast.success('Member(s) terminated successfully', { position: 'top-center' });
        onComplete();
      } else {
        toast.error('Failed to terminate member(s)', { position: 'top-center' });
      }
    } finally {
      setTermDate('');
      setDisabledBtn(false);
      onClose(false);
      setSelectedMember(null);
      setIsLoading(false);
    }
  };

  const CustomButtons = () => {
    return (
      <div className="flex gap-4">
        <Button title="No" kind="secondary" onClick={() => onClose(false)} />
        <ButtonWithIconAndLoader
          title="Yes, terminate"
          kind="primary"
          onClick={handleMemberTermination}
          labelClasses="pr-1"
          loading={isLoading}
          disabled={disabledBtn}
        />
      </div>
    );
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => onClose(false)}
      header="Terminate"
      customFooterActions={{
        right: <CustomButtons />
      }}
      size="small"
    >
      <section className="p-6 space-y-4 font-bold font-effra">
        <p>
          You are about to terminate {member?.firstName} {member?.lastName}. Are you sure you'd like to proceed?
        </p>
        <div className="w-1/3">
          <DatePicker
            data-testid="date-picker-input-terminate-member"
            label="Termination Date"
            name="terminate-member"
            value={termDate ? moment(termDate).format(DATE_DISPLAY_FORMAT) : ''}
            minDate={moment().add(1, 'days').toDate()}
            onChange={(value: any) => {
              setTermDate(moment(value).format(DATE_API_FORMAT));
            }}
          />
        </div>
      </section>
    </Modal>
  );
};
